<div style="display: flex; flex-direction: column; width: 100%; height: 100%;" data-cy="testing-container">
  <div data-cy="testing-label">Test</div>
  <div style="width: 200px; height: 30px;" data-cy="testing-time-input-container">
    <tdo-time-input widthString="100%" [value]="today" data-cy="testing-time-input"></tdo-time-input>
  </div>
  <div></div>
  <div style="display: flex; flex-basis: fit-content;" data-cy="testing-section-buttons">
    <button (click)="section = 'notes'" class="tdo-button tdo-save" data-cy="testing-notes-button">Notes</button>
    <button style="margin-left: 10px;" (click)="section = 'socket'; startSocketTesting()" class="tdo-button tdo-save" data-cy="testing-socket-button">Socket</button>
    <button style="margin-left: 10px;" (click)="section = 'azureblob'; startAzureBlobTesting()" class="tdo-button tdo-save" data-cy="testing-azure-blob-button">Azure Blob</button>
    <button style="margin-left: 10px;" (click)="section = 'enumselect';" class="tdo-button tdo-save" data-cy="testing-enum-select-button">Enum Select</button>
  </div>
  <div style="flex: 1; padding-top: 20px;" data-cy="testing-content-area">
    <tdo-patient-search (patientSelect)="onPatientSelect($event)" data-cy="testing-patient-search"></tdo-patient-search>
    <div *ngIf="section === 'notes'" data-cy="testing-notes-section">
      <button (click)="filterNotes()" class="tdo-button tdo-save" data-cy="testing-filter-notes-button">Filter notes by Initial Consultation</button>
    </div>
    <div *ngIf="section === 'socket'" data-cy="testing-socket-section">
      <style type="text/css">
        p {
          color: #000;
          font-size: 8.7em;
          font-family: Helvetica, Arial;
          padding-top: 0%;
          margin-left: 25%;
        }
      </style>
      <div id="timediv" data-cy="testing-socket-time-div">
        <p data-cy="testing-socket-messages">{{allMessages}}</p>
      </div>
    </div>
    <div *ngIf="section === 'azureblob'" data-cy="testing-azure-blob-section">
      <div style="display: flex;" data-cy="testing-azure-blob-header">
        <h2 data-cy="testing-azure-blob-title">Blobs</h2>
        <div style="margin-left: 20px;"><button (click)="listBlobsClick()" class="tdo-button tdo-save" data-cy="testing-list-blobs-button">List blobs</button></div>
        <input multiple #uploadInput type="file" style="display: none;" (change)="onAzureUploadFileChange(uploadInput.files)" data-cy="testing-upload-input" />
        <button style="margin-left: 30px;" (click)="uploadInput.click()" class="tdo-button tdo-save" data-cy="testing-upload-button">Upload file</button>
      </div>
      <h4 data-cy="testing-list-label">List</h4>
      <br />
      <br />
      <table data-cy="testing-blobs-table">
        <tr *ngFor="let pic of picturesList" data-cy="testing-blob-row">
          <td data-cy="testing-blob-name">{{pic}}</td>
          <td><button class="tdo-button tdo-save" (click)="downloadBlob(pic)" download="pic" data-cy="testing-download-blob-button">DOWNLOAD</button></td>
          <td><button class="tdo-button" style="background-color: red;" (click)="deleteBlob(pic)" data-cy="testing-delete-blob-button">DELETE</button></td>
        </tr>
      </table>
    </div>
    <div *ngIf="section === 'enumselect'" data-cy="testing-enum-select-section">
      <div style="width: 200px" data-cy="testing-dropdown-v2-container">
        <tdo-dropdown-v2 data-cy="testing-dropdown-v2"></tdo-dropdown-v2>
      </div>
      <div style="display: flex; margin-top: 3px;" data-cy="testing-form-controls">
        <div style="width: 200px" data-cy="testing-enum-select-container">
          <app-tdo-enum-select placeholder="Type" placeholderPosition="above" name="enumOrganizationContactType" data-cy="testing-enum-select"></app-tdo-enum-select>
        </div>
        <div style="flex-basis: 20px;"></div>
        <tdo-input placeholder="Test" placeholderPosition="above" data-cy="testing-input"></tdo-input>
      </div>
    </div>
  </div>
</div>
